import { z } from 'zod';
import { MODULOS, PAQUETES_COMERCIALES } from '../catalogos/modulos.js';
import { esquemaSubdominio, esquemaSlugNuevo } from './accesos.js';
import { esquemaMotivo, esquemaZonaHoraria } from './comunes.js';
import { ESTADOS_COMERCIALES, ESTADOS_OPERATIVOS, } from './suscripcion.js';
const esquemaPagina = z.coerce.number().int().min(1).max(10_000).default(1);
const esquemaTamano = z.coerce.number().int().min(5).max(100).default(25);
export const VENTANAS_DE_VENCIMIENTO = ['vencido', '7', '14', '30'];
export const ORDENES_DE_CONSULTORIOS = ['nombre', 'alta', 'vence', 'usuarios'];
/** Filtros del listado de consultorios (y del de suscripciones, que es el mismo conjunto). */
export const esquemaFiltroDeConsultorios = z.object({
    q: z.string().trim().max(120).default(''),
    estado: z.enum([...ESTADOS_OPERATIVOS, 'todos']).default('todos'),
    suscripcion: z
        .enum([...ESTADOS_COMERCIALES, 'sin-suscripcion', 'todas'])
        .default('todas'),
    /** Clave del plan comercial, `sin-plan` o `todos`. */
    plan: z.string().trim().max(60).default('todos'),
    vence: z.enum([...VENTANAS_DE_VENCIMIENTO, 'todos']).default('todos'),
    /** Solo los que necesitan atencion (ver `MotivoDeAtencion`). */
    atencion: z
        .enum(['si', 'no'])
        .default('no')
        .transform((v) => v === 'si'),
    /** Solo los que tienen un subdominio o dominio sin terminar de configurar. */
    dominio: z.enum(['pendiente', 'todos']).default('todos'),
    orden: z.enum(ORDENES_DE_CONSULTORIOS).default('nombre'),
    dir: z.enum(['asc', 'desc']).default('asc'),
    pagina: esquemaPagina,
    tamano: esquemaTamano,
});
/** Por que un consultorio aparece como «necesita atencion». */
export const MOTIVOS_DE_ATENCION = [
    'pendiente-activacion',
    'sin-propietario',
    'pago-pendiente',
    'restringida',
    'vence-pronto',
    'dominio-pendiente',
    'suspendido',
];
/** Dias antes de un vencimiento en que el consultorio pide atencion. */
export const DIAS_DE_AVISO_DE_VENCIMIENTO = 14;
export const esquemaFiltroDeActividad = z.object({
    organizacionId: z
        .string()
        .regex(/^[a-f0-9]{24}$/i)
        .optional(),
    accion: z.string().trim().max(60).optional(),
    pagina: esquemaPagina,
    tamano: esquemaTamano,
});
// --- Edicion y estado del consultorio -----------------------------------------
export const esquemaEdicionDeConsultorio = z
    .object({
    nombre: z.string().trim().min(2).max(120).optional(),
    zonaHoraria: esquemaZonaHoraria.optional(),
    motivo: esquemaMotivo,
})
    .strict()
    .refine((d) => d.nombre !== undefined || d.zonaHoraria !== undefined, {
    message: 'No hay nada que cambiar',
});
/** Suspender o reactivar un consultorio: siempre con motivo. */
export const esquemaEstadoDeConsultorio = z
    .object({ suspendido: z.boolean(), motivo: esquemaMotivo })
    .strict();
// --- Alta guiada --------------------------------------------------------------
/**
 * Alta guiada en cinco pasos (consultorio, propietario, plan, acceso, revision).
 *
 * Idempotente por slug: repetirla con el mismo slug mientras el consultorio
 * sigue aprovisionandose no crea otro; completa lo que falto (plan, invitacion).
 */
export const esquemaAltaGuiada = z
    .object({
    organizacion: z
        .object({
        nombre: z.string().trim().min(2).max(120),
        slug: esquemaSlugNuevo,
        zonaHoraria: esquemaZonaHoraria,
        /** Modulo de especialidad del consultorio, si tiene una. */
        especialidad: z.enum(MODULOS).nullable().default(null),
        subdominio: esquemaSubdominio.nullable().default(null),
    })
        .strict(),
    propietario: z
        .object({
        nombre: z.string().trim().min(2).max(120),
        correo: z.string().trim().toLowerCase().email(),
    })
        .strict(),
    /** Plan del catalogo. Sin plan, el consultorio arranca con el paquete. */
    planComercialId: z
        .string()
        .regex(/^[a-f0-9]{24}$/i, 'Plan inválido')
        .nullable()
        .default(null),
    paquete: z.enum(PAQUETES_COMERCIALES),
    /** `prueba` exige `finDePrueba`. */
    inicio: z.enum(['activa', 'prueba']).default('activa'),
    finDePrueba: z.coerce.date().optional(),
    /** Activar en cuanto el propietario acepte (si no falta nada mas). */
    activarAlAceptar: z.boolean().default(true),
})
    .strict()
    .refine((d) => d.inicio !== 'prueba' || d.finDePrueba !== undefined, {
    message: 'Una prueba necesita fecha de fin',
    path: ['finDePrueba'],
})
    .refine((d) => d.inicio !== 'prueba' || d.planComercialId !== null, {
    message: 'Una prueba se configura sobre un plan del catálogo',
    path: ['planComercialId'],
});
//# sourceMappingURL=consola.js.map